import Vue from 'vue'

import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/scss/normalize.scss'
import './icons'
import App from './App.vue'

import axios from './service/axios'
import apis from './service/api'
import VueClipboards from 'vue-clipboards';


Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$apis = apis

Vue.use(Vant);
Vue.use(VueClipboards);

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
  },
  mounted () {
  }
}).$mount('#app')
